module.exports = __webpack_public_path__ + "static/media/account.a24f8214.svg";